/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import GlobalConfig from '../app.config.js';

export const usePageEntrance = () => {
  const [once, setOnce] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    if (once || startedRef.current) {
      return;
    }

    setOnce(true);
    startedRef.current = true;

    const timeline = gsap.timeline();
    let int: ReturnType<typeof setInterval>;
    let fallback: ReturnType<typeof setTimeout>;

    const revealElements = () => {
      clearInterval(int);
      clearTimeout(fallback);
      const enterEls = document.querySelectorAll(
        '.enter-el, .enter-el-block, .enter-el-inherit'
      );
      timeline
        .fromTo(
          enterEls,
          { y: 40 },
          {
            y: 0,
            stagger: 0.07,
            force3D: true,
            duration: 1.4,
            ease: 'expo.out',
          }
        )
        .fromTo(
          enterEls,
          { opacity: 0 },
          {
            opacity: 1,
            stagger: 0.07,
            force3D: true,
            duration: 1.35,
            ease: 'expo.out',
          },
          0.05
        );
    };

    int = setInterval(() => {
      if (GlobalConfig.transitionFinished) {
        revealElements();
      }
    }, 50);

    fallback = setTimeout(revealElements, 3500);

    return () => {
      clearInterval(int);
      clearTimeout(fallback);
      timeline.kill();
    };
  }, [once]);
};
